import AuthFormContainer from '../styled/auth-form-container'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <AuthFormContainer>
      Oops!  Something went wrong...you were likely logged out due to inactivity.
      <br />
      <Link to='/login'>Click here to log back in.</Link>
    </AuthFormContainer>
  )
}

export default NotFound
